// extracted by css-extract-rspack-plugin
export default {"adminSelected":"r3LH2","adminUnselected":"ybbn4","hubSelected":"kjIT4","hubUnselected":"sS0A_"};